var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card" },
    [
      _vm.profile && _vm.profile.logo
        ? _c("div", { staticClass: "card-body" }, [
            _c("img", {
              staticClass: "my-4 mx-auto d-block",
              staticStyle: { width: "150px" },
              attrs: { src: _vm.profile.logo, alt: "School Logo" },
            }),
          ])
        : _c("div", { staticClass: "card-body" }, [
            _c("img", {
              staticClass: "my-4 mx-auto d-block",
              staticStyle: { width: "150px" },
              attrs: { src: "/assets/img/logo.png", alt: "School Logo" },
            }),
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card-footer",
          staticStyle: { "background-color": "#EAEAEB" },
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-block btn-default sgp-btn-default",
              on: { click: _vm.onUpdateLogo },
            },
            [_vm._v("\n            Update School Logo\n        ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("school-logo-upload", {
        attrs: { project: _vm.project },
        on: { success: _vm.onUploadSuccess, failure: _vm.onUploadFailure },
        model: {
          value: _vm.upload,
          callback: function ($$v) {
            _vm.upload = $$v
          },
          expression: "upload",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }